import { clippApi } from 'api';
import { ClippInfo } from 'pco-product-service-internal-consumer';

export const getClippPricingData = async (partnerNumber: string): Promise<ClippInfo> => {
  return await clippApi.getProspectClippInfo({ prospectUid: partnerNumber });
};
